<template>
    <div class="product-count-image-slot">  
        <image-stream :src="`https://product-count.omniview.cloud/frame.jpg?id=${id}`" class="frame"/>
    </div>
</template>

<script>
import layoutMixin from "@/mixins/layoutMixin";
import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { v4 as uuidv4 } from "uuid";
import { ref } from "@vue/composition-api";
import ImageStream from './ImageStream.vue';

export default {
mixins: [layoutMixin],
components: {
    BFormInput,
    BButton,
    BFormGroup,
    ImageStream,
},
props: {
    data: {
    type: Object,
    },
},
directives: {
    Ripple,
},
setup() {
    const id = ref(uuidv4());
    setInterval(() => {
        id.value = uuidv4();
    }, 3000)

    return {
        id,
    }
}
};
</script>

<style lang="scss" scoped>
.product-count-image-slot {
    width: 100%;
    height: 100%;
}

.frame {
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
}
</style>
